import { render, staticRenderFns } from "./PlosP.vue?vue&type=template&id=00e78df1"
import script from "./PlosP.vue?vue&type=script&lang=js"
export * from "./PlosP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports